import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import FeaturesHero from './components/FeaturesHero';
import FeaturesDeepDive from './components/FeaturesDeepDive';
import FeaturesGrid from './components/FeaturesGrid';
import FeaturesComparison from './components/FeaturesComparison';
import FeaturesTestimonials from './components/FeaturesTestimonials';
import FeaturesFAQ from './components/FeaturesFAQ';
import { Link } from 'react-router-dom';

export default function FeaturesPage() {
  return (
    <>
      <title>AI Ad Generator Features | AdForge — AI Copy, Images & Visual Editor</title>
      <meta
        name="description"
        content="Explore every feature of AdForge's AI ad generator: AI-written ad copy, AI-generated creative images, visual editor, multi-platform formatting, A/B variations & more. Free to start."
      />
      <meta
        name="keywords"
        content="AI ad generator features, AI ad copy, AI advertising images, ad visual editor, multi-platform ad generator, AI marketing features"
      />
      <link rel="canonical" href="https://adforge.ai/features" />
      <meta name="Last-modified" content={new Date().toISOString().split('T')[0]} />

      <meta property="og:type" content="website" />
      <meta property="og:title" content="AI Ad Generator Features | AdForge" />
      <meta property="og:description" content="AI copy + AI images + visual editor. Explore all AdForge features for creating better ads faster." />
      <meta property="og:url" content="https://adforge.ai/features" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="AI Ad Generator Features | AdForge" />
      <meta name="twitter:description" content="Every feature you need to create professional ads with AI — no experience required." />

      <script type="application/ld+json">{JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'AI Ad Generator Features — AdForge',
        description: 'Complete feature breakdown of AdForge AI ad generator: AI copy, AI images, visual editor, A/B testing, and more.',
        url: 'https://adforge.ai/features',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://adforge.ai' },
            { '@type': 'ListItem', position: 2, name: 'Features', item: 'https://adforge.ai/features' },
          ],
        },
      })}</script>

      <div className="min-h-screen bg-white">
        <Navbar />
        <main>
          <FeaturesHero />
          <FeaturesDeepDive />
          <FeaturesGrid />
          <FeaturesComparison />
          <FeaturesTestimonials />
          <FeaturesFAQ />

          {/* Final CTA */}
          <section className="py-20 lg:py-24 relative overflow-hidden">
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=elegant%20dark%20background%20with%20soft%20glowing%20amber%20orange%20geometric%20light%20patterns%2C%20abstract%20minimal%20tech%20art%2C%20wide%20panoramic%20format%2C%20rich%20warm%20tones%2C%20no%20text%2C%20premium%20modern%20aesthetic&width=1920&height=560&seq=features-cta-bg-01&orientation=landscape"
                alt=""
                className="w-full h-full object-cover object-top"
                aria-hidden="true"
              />
              <div className="absolute inset-0 bg-black/60" />
            </div>
            <div className="relative z-10 max-w-3xl mx-auto px-6 lg:px-8 text-center">
              <h2 className="text-3xl lg:text-4xl font-black text-white mb-4 leading-tight">
                Every Feature. Included. From Day One.
              </h2>
              <p className="text-stone-300 text-base mb-8 leading-relaxed">
                No feature gating, no confusing tiers. All the tools that make AdForge the{' '}
                <strong className="text-white">best AI ad generator</strong> are available on every plan — including free.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6">
                <Link
                  to="/signup"
                  className="px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-bold text-base rounded-xl transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  Try All Features Free
                </Link>
                <Link
                  to="/how-it-works"
                  className="px-8 py-4 bg-white/10 hover:bg-white/20 border border-white/20 text-white font-semibold text-base rounded-xl transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  How It Works
                </Link>
              </div>
              <p className="text-xs text-stone-400">No credit card required &middot</p>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}
